import {
    getDataWithParams,
    getData
} from '@/store/config/method'
const initRequest = {
    sorting: null,
    sortingLabel: 'Paling Sesuai',
    sortBy: null,
    type: null,
    typeLabel: 'Semua Tipe',
    show: 8,
    page: 1
}
const initialState = () => ({
    message: 'Jaringan Bermasalah',
    status: 0,
    request: {...initRequest},
    landing: [],
    list: [], 
    related: [],
    meta: {},
    detail: {},
})
const state = initialState
const getters = {
    getStatus: state => state.status,
    getMessage: state => state.message,
    getRequest: state => state.request,
    getLanding: state => state.landing,
    getRelated: state => state.related,
    getList: state => state.list,
    getMeta: state => state.meta,
    getDetail: state => state.detail || {},
}

const actions = {
    async getLandingData({
        commit
    }, slug = '') {
        try {
            const url = '/announcement-data/landing' + slug
            const response = await getData(url);
            commit('SET_RESPONSE', response.data);
            if(slug != '') commit('SET_RELATED', response.data.data);
            else commit('SET_LANDING', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
   
    async getListData({
        commit, state
    }) {
        try {
            const url = '/announcement-data/all'
            const response = await getDataWithParams(url, state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_LIST', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getDetailData({
        commit
    }, slug) {
        try {
            const url = `/announcement-data/by-slug/${slug}`
            const response = await getDataWithParams(url, {});
            commit('SET_RESPONSE', response.data);
            commit('SEt_DETAIL_DATA', response.data.data);
        } catch (err) {
            commit('SEt_DETAIL_DATA', {});
            if(err.response){
                commit('SET_FAILED_MSG', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.message = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error.status == 400){
            state.message = error.data.msg
            state.status = error.data.status
        }else{
            state.message = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response){
        state.message = response.msg
        state.status = response.status
    },
    SET_LANDING(state, value){
        state.landing = value
    },
    SET_RELATED(state, value){
        state.related = value
    },
    SEt_DETAIL_DATA(state, value){
        state.detail = value
    },
    SET_LIST(state, response){
        const temp = response
        const lastData = state.request.page == 1 ? [] : [...state.list]
        state.list = [...lastData, ...temp.data]
        delete temp.data
        state.meta = temp
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}